<div class="evento" *ngIf="evento">{{evento.descricao}}  
  
  <div class="temporal">Data de Realização:<b>{{evento.dia}}</b> Horário:<b>{{evento.horario}}h</b></div>
  <div class="eventoSub">Preencha o formulário abaixo e garanta sua inscrição.</div>
</div>
<div *ngIf="!inscrito && !fechado">
<form [formGroup]="formulario" (ngSubmit)="salvar()">
  <div style="text-align:center">
  <div class="celula">
    <span class="mostradores" pTooltip="CPF do participante" tooltipPosition="top" style="font-weight: bolder">CPF* </span>
                       
    <p-inputMask [style]="{'width':'100%'}" [mask]="maskCPFCNPJ" formControlName="cpf" (onBlur)="verificarCPF()"></p-inputMask>
    
  </div>
  <div class="celula">
    <span class="mostradores" pTooltip="Nome do Participante" tooltipPosition="top">Nome Completo*</span>
    <input style="width: 100%;" pInputText formControlName="nome" placeholder="Nome completo do participante">
    

  </div>
  <div class="celula">
    <span class="mostradores" pTooltip="Endereço de Email" tooltipPosition="top">Email*</span>
    <input style="width: 100%;" pInputText formControlName="email"  placeholder="Email">
    

  </div>
  <div class="celula">
    <span class="mostradores" pTooltip="Origem" tooltipPosition="top">Origem*</span>
    <p-dropdown [options]="origens"  formControlName="origem" filter="true"   [style]="{'width':'100%'}"></p-dropdown>
    

  </div>
  
    <div class="salvar" (click)="salvar()">Inscrever</div>
  </div>
  
 
  


</form>
</div>

<div *ngIf="evento && inscrito" class="inscrito">
  Inscrição Realizada <br>
  <div class="subInscrito">
    A reunião se dará no dia {{evento.dia}} as {{evento.horario}} e, o link para a mesma será enviado por email no mesmo dia, com cerca de 01 hora de antecedencia.
  </div>

</div>

<div *ngIf="fechado" class="inscritod">
  Evento Fechado. 
  <div class="subInscrito">
    <br>
   As inscrições para este evento já estão esgotadas ou a data do mesmo já se passou.
  </div>

</div>